import { render } from "./AddGangModal.vue?vue&type=template&id=843c5086&scoped=true"
import script from "./AddGangModal.vue?vue&type=script&lang=js"
export * from "./AddGangModal.vue?vue&type=script&lang=js"

import "./AddGangModal.vue?vue&type=style&index=0&id=843c5086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-843c5086"]])

export default __exports__